import { useEffect, useState } from "react";

// On-screen object selection: while active, clicks on any element carrying
// data-aria-key toggle it into the selection instead of performing its action.
export const useObjectSelection = ({ onActivate }) => {
  const [selectMode, setSelectMode] = useState(false);
  const [selection, setSelection] = useState([]);

  useEffect(() => {
    if (!selectMode) return undefined;
    document.body.classList.add("aria-select-mode");
    const onClick = (e) => {
      const el = e.target.closest("[data-aria-key]");
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      const key = el.getAttribute("data-aria-key");
      const [type, ...rest] = key.split(":");
      const id = rest.join(":");
      const label = el.getAttribute("data-aria-label") || key;
      setSelection((sel) => (sel.some((s) => s.key === key)
        ? sel.filter((s) => s.key !== key)
        : [...sel, { key, type, id, label }]));
    };
    const onPointerDown = (e) => {
      if (e.target.closest("[data-aria-key]")) e.stopPropagation();
    };
    const onEsc = (e) => { if (e.key === "Escape") setSelectMode(false); };
    document.addEventListener("click", onClick, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    window.addEventListener("keydown", onEsc);
    return () => {
      document.body.classList.remove("aria-select-mode");
      document.removeEventListener("click", onClick, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
      window.removeEventListener("keydown", onEsc);
    };
  }, [selectMode]);

  const toggleSelectMode = () => {
    setSelectMode((m) => !m);
    if (!selectMode) onActivate?.();
  };

  const clearSelection = () => {
    setSelection([]);
    setSelectMode(false);
  };

  return { selectMode, selection, setSelection, toggleSelectMode, clearSelection };
};
